import { ShowBase, useShowContext } from "ra-core";
import { EstimateDetail } from "./EstimateDetail";

function Content() {
  const { record, isPending } = useShowContext<any>();
  if (isPending || !record) return null;
  return <EstimateDetail estimateId={record.id} />;
}

export function EstimateShow() {
  return (
    <ShowBase>
      <Content />
    </ShowBase>
  );
}
